import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTipWithPermission from "../../../../../components/CustomToolTipWithPermission";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { VIEWER_ACCESS_DENIED_MESSAGE } from "../../../../../utils/constants";
import { icons } from "../../../environment/icons/iconExport";

const AssetActionMenu = ({
  handleOpenUpdateModal,
  handleSwitchChange,
  handleDeleteAsset,
  isActive,
  editLabel = "Edit",
  hasPermission,
}) => {
  const colors = useColors();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const { trackEvent } = useAPI();

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    trackEvent("User clicked on asset action menu");
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    trackEvent("User closed asset action menu");
    setMenuAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        onClick={handleMenuOpen}
        sx={{
          border: "1px solid " + colors.grey_300,
          borderRadius: "6px",
          width: "24px",
          height: "24px",
          "&:hover": {
            backgroundColor: colors.grey_100,
          },
        }}
      >
        <SvgToIcon
          IconLogo={icons.MenuVerticalIcon}
          width="16px"
          height="16px"
          style={{
            color: colors.text_secondary,
          }}
        />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          color: colors.contrast_text_dark,
          "& .MuiPaper-root": {
            borderRadius: "8px",
            minWidth: "150px",
            border: "1px solid " + colors.divider2,
            boxShadow: "0px 1px 4px 0px " + colors.black_10percent,
          },
          "& .MuiList-root": {
            padding: "4px 8px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0px 0px 5.3px 0px " + colors.primary_32percent,
            minWidth: "120px",
          },
        }}
      >
        {handleOpenUpdateModal && (
          <CustomToolTipWithPermission
            title={hasPermission ? "" : VIEWER_ACCESS_DENIED_MESSAGE}
            permission={hasPermission}
            placement="top"
          >
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                hasPermission && handleOpenUpdateModal(e);
                handleMenuClose();
              }}
              sx={{
                py: 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: hasPermission ? "pointer" : "default",
              }}
            >
              <SvgToIcon
                IconLogo={icons.EditIcon2}
                width="16px"
                height="16px"
                style={{ color: colors.text_secondary }}
              />

              <Typography variant="caption">{editLabel}</Typography>
            </MenuItem>
          </CustomToolTipWithPermission>
        )}
        {handleSwitchChange && (
          <CustomToolTipWithPermission
            title={hasPermission ? "" : VIEWER_ACCESS_DENIED_MESSAGE}
            permission={hasPermission}
            placement="top"
          >
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                hasPermission && handleSwitchChange(e);
                handleMenuClose();
              }}
              sx={{
                py: 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: hasPermission ? "pointer" : "default",
              }}
            >
              <SvgToIcon
                IconLogo={icons.ToggleIcon}
                width="16px"
                height="16px"
                style={{ color: colors.text_secondary }}
              />
              <Typography variant="caption">
                {isActive ? "Disable Smart Asset" : "Activate Smart Asset"}
              </Typography>
            </MenuItem>
          </CustomToolTipWithPermission>
        )}
        {handleDeleteAsset && (
          <CustomToolTipWithPermission
            title={hasPermission ? "" : VIEWER_ACCESS_DENIED_MESSAGE}
            permission={hasPermission}
            placement="top"
          >
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                hasPermission && handleDeleteAsset(e);
                handleMenuClose();
              }}
              sx={{
                py: 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: hasPermission ? "pointer" : "default",
              }}
            >
              <SvgToIcon
                IconLogo={icons.DeleteBinIcon2}
                width="16px"
                height="16px"
                style={{ color: colors.text_secondary }}
              />
              <Typography variant="caption">{"Delete"}</Typography>
            </MenuItem>
          </CustomToolTipWithPermission>
        )}
      </Menu>
    </Box>
  );
};

export default AssetActionMenu;
